/* eslint-disable no-undef */
import { FunctionComponent } from 'react';
import CourseLanding from '../../components/courseLanding';
import SectionTitle from '../../components/sectionTitle';
import Quiz from '../../components/quiz';
import Conversation from './conversation';
import Animation004 from './animation004';
import Animation006 from './animation006';
import Animation011 from './animation011';
import Animation014 from './animation014';
import Animation019 from './animation019';
import Animation022 from './animation022';
import Animation025 from './animation025';
import Animation029 from './animation029';
import Animation046 from './animation046';
import Animation047 from './animation047';
import Animation032 from './animation032';
import Animation033 from './animation033';
import Animation034 from './animation034';
import Animation037 from './animation037';
import Animation041 from './animation041';
import Animation043 from './animation043';
import Animation044 from './animation044';
import Component001 from './component001';
import Component002 from './component002';
import Component003 from './component003';
import Component004 from './component004';
import Component005 from './component005';
import Component010 from './component010';
import Component012 from './component012';
import Component013 from './component013';

const Components: {
  [key: string]: FunctionComponent<any>;
} = {
  Quiz,
  CourseLanding,
  SectionTitle,
  Conversation,
  Animation004,
  Animation006,
  Animation011,
  Animation014,
  Animation019,
  Animation022,
  Animation025,
  Animation029,
  Animation032,
  Animation033,
  Animation034,
  Animation037,
  Animation041,
  Animation043,
  Animation044,
  Animation046,
  Animation047,
  Component001,
  Component002,
  Component003,
  Component004,
  Component005,
  Component010,
  Component012,
  Component013,
};

export default Components;
